import React, { useState, useEffect } from 'react';
import {
    Box, Typography, Button, Paper, Alert, CircularProgress,
    TextField, Tabs, Tab,
    Table, TableHead, TableRow, TableCell, TableBody
} from '@mui/material';
import api from '../../api/axios';

const EmployeeLeaveRequest = () => {

    const [tab, setTab] = useState(0);

    const [form, setForm] = useState({
        startDate: '',
        endDate: '',
        reason: ''
    });

    const [list, setList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');
    const [error, setError] = useState('');

    // 🔥 LOAD MY REQUESTS
    const load = async () => {
        try {
            const res = await api.get('/leaves/me');
            setList(res.data);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const change = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError('');
        setMsg('');

        try {
            await api.post('/leaves', form);

            setMsg("Leave Applied Successfully");
            setForm({ startDate: '', endDate: '', reason: '' });

            load(); // 🔥 refresh

        } catch (err) {
            setError(err.response?.data?.message || "Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 4 }}>

            <Typography variant="h4" mb={2}>
                Leave Management
            </Typography>

            {error && <Alert severity="error">{error}</Alert>}
            {msg && <Alert severity="success">{msg}</Alert>}

            <Tabs value={tab} onChange={(e, v) => setTab(v)}>
                <Tab label="Apply Leave" />
                <Tab label="My Requests" />
            </Tabs>

            {/* ================= APPLY ================= */}
            {tab === 0 && (
                <Paper sx={{ p: 3, mt: 2 }}>

                    <form onSubmit={submit}>

                        <TextField
                            fullWidth
                            type="date"
                            name="startDate"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            value={form.startDate}
                            onChange={change}
                            sx={{ mb: 2 }}
                        />

                        <TextField
                            fullWidth
                            type="date"
                            name="endDate"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            value={form.endDate}
                            onChange={change}
                            sx={{ mb: 2 }}
                        />

                        <TextField
                            fullWidth
                            name="reason"
                            label="Reason"
                            multiline
                            rows={3}
                            value={form.reason}
                            onChange={change}
                            sx={{ mb: 2 }}
                        />

                        <Button variant="contained" type="submit">
                            {loading ? <CircularProgress size={20} /> : "Submit"}
                        </Button>

                    </form>

                </Paper>
            )}

            {/* ================= MY REQUESTS ================= */}
            {tab === 1 && (
                <Paper sx={{ p: 3, mt: 2 }}>

                    <Typography variant="h6" mb={2}>
                        My Requests
                    </Typography>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Start</TableCell>
                                <TableCell>End</TableCell>
                                <TableCell>Reason</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Remark</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {list.map((l) => (
                                <TableRow key={l.id}>
                                    <TableCell>{l.startDate}</TableCell>
                                    <TableCell>{l.endDate}</TableCell>
                                    <TableCell>{l.reason}</TableCell>
                                    <TableCell>
                                        <b style={{
                                            color:
                                                l.status === 'APPROVED' ? 'green' :
                                                    l.status === 'REJECTED' ? 'red' :
                                                        'orange'
                                        }}>
                                            {l.status}
                                        </b>
                                    </TableCell>
                                    <TableCell>{l.managerRemark || '-'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </Paper>
            )}

        </Box>
    );
};

export default EmployeeLeaveRequest;